import api from '../requests';
import moment from 'moment';
import { filterString, toUpper, isEmptyArray } from '../../util/functions';
import { NMS_ORDER_CATEGORY } from '../../util/orderFilterConstants';
const FileDownload = require('js-file-download');
import queryString from 'query-string';

export function getOrderQueryString (params) {
  let queryParams = {
    symbol: toUpper(params.symbol),
    mpid: toUpper(params.mpid),
    startDate: params.startDate,
    endDate: params.endDate,
    startTime: params.startTime,
    endTime: params.endTime,
    orderEnterStartTime: params.orderEnterStartTime,
    orderEnterEndTime: params.orderEnterEndTime,
    side: filterString(params.side),
    linkId: params.linkId,
    linkAtsId: params.linkAtsId,
    orderCapacity: params.orderCapacity,
    clientOrderId: params.clientOrderId,
    orderStatus: filterString(params.orderStatus),
    orderId: params.orderId,
    minPrice: params.minPrice,
    maxPrice: params.maxPrice,
    minSize: params.minSize,
    maxSize: params.maxSize,
    category: filterString(params.category),
    tifFilter: filterString(params.tifFilter),
    sortDir: params.sortDir,
    sortOn: params.sortOn
  };
  return queryString.stringify(queryParams);
}

export async function getNmsOrders (params, sort) {
  if (isEmptyArray(params.category)) {
    params.category = NMS_ORDER_CATEGORY;
  }
  let orderQueryObject = { ...params, ...sort };
  let query = getOrderQueryString(orderQueryObject);
  // console.log(query);

  const response = await api.request({
    method: 'get',
    url: `/internal/nms/order-data?${query}`
  });
  return response.data;
}

export async function downloadNmsOrders (params) {
  // always provide category ,its needed for indexing
  if (isEmptyArray(params.category)) {
    params.category = NMS_ORDER_CATEGORY;
  }
  let query = getOrderQueryString(params);
  //  console.log(query);

  const response = await api.request({
    method: 'get',
    responseType: 'blob',
    url: `/internal/nms/order-data/download?${query}`
  });

  FileDownload(response.data, `MOON_Order-${moment().format('MM/DD/YYYY')}.csv`);
}

/// OPEN ORDER

export async function getNmsOpenOrders (params, sort) {
  let orderQueryObject = { ...params, ...sort };
  // console.log('param', orderQueryObject);
  let query = getOrderQueryString(orderQueryObject);
  // console.log(query);

  const response = await api.request({
    method: 'get',
    url: `/internal/nms/order-data/open/?${query}`
  });
  return response.data;
}

export async function downloadNmsOpenOrders (params) {
  let query = getOrderQueryString(params);

  const response = await api.request({
    method: 'get',
    responseType: 'blob',
    url: `/internal/nms/order-data/open/download?${query}`
  });

  FileDownload(response.data, `MOON_Open_Order-${moment().format('MM/DD/YYYY')}.csv`);
}
